import React, { useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { OnboardingStatusDots, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { CompanyForm } from 'forms';
import { useOnboardingContext } from './onboarding.context.hook';
import { EOnboardingStep } from 'enums';
import { DialogPrevNextClose } from './dialog-prev-next-close';

interface OnboardingCompanyDialogProps {
  visible?: boolean;
}

export const OnboardingCompanyDialog = ({ visible = false }: OnboardingCompanyDialogProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState<boolean>(false);
  const { setVisible, updateOnboarding } = useOnboardingContext();

  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  const onNext = () => {
    updateOnboarding({ status: EOnboardingStep.APPROVE_DECAL });
  };

  const onPrev = () => {
    updateOnboarding({ status: EOnboardingStep.SETUP_ZONE });
  };

  const next = () => {
    updateOnboarding({ status: EOnboardingStep.APPROVE_DECAL });
  };

  const title = 'Let’s set up your facility profile.';
  const subtitle = 'Don’t worry, you can edit all of this in your Account.';
  const submitButtonLabel = 'Approve your Decal';

  return (
    <Dialog
      onClose={onClose}
      open={visible}
      PaperProps={{ sx: { marginBottom: 12, ...(down_sm ? {} : { overflow: 'visible' }) } }}
    >
      <DialogTitle>
        <DialogPrevNextClose onPrev={onPrev} onNext={onNext} onClose={onClose} />

        <Box>
          <Typography variant="subtitle2" color="textSecondary">
            Step 3 of 6
          </Typography>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <Typography variant="h5">{title}</Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              marginTop: 1,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box paddingTop={2}>
          <CompanyForm ref={formRef} onSubmitting={(loading) => setLoading(loading)} next={next} />
        </Box>
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <Box
        sx={{
          width: '100%',
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          ...(down_sm ? { paddingBottom: 6 } : { position: 'absolute', bottom: -60 }),
        }}
      >
        <OnboardingStatusDots status={EOnboardingStep.COMPANY_BRAND_SETTING} />
      </Box>
    </Dialog>
  );
};
